import React, { useEffect, useState } from 'react';
import makeRequest from 'utils/makeRequest';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import IPLWidget from 'components_v2/mobile/IPLWidget/IPLWidgetV3';
import TOIPlusWidget from 'components_v3/desktop/TOIPlusWidget/TOIPlusWidget';

const EpaperIplWidgetWrapper = props => {
  const { dataUrl, itemIndex, cssObject } = props;

  const [showIplWidget, setShowIplWidget] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [iplData, setIplData] = useState(null);

  useEffect(() => {
    if (dataUrl) {
      makeRequest
        .get(dataUrl)
        .then(response => {
          const { data } = response;
          if (data && data.matches) {
            setIplData(data);
            setShowIplWidget(true);
          }
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error fetching IPL data:', error);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <ErrorBoundary>
      <li
        key={`toipluswidget-${itemIndex}`}
        className={`${cssObject.cardListItem} ${
          cssObject.minHeightCardListItem
        }`}
      >
        {isLoading ? (
          <LoaderSpinner />
        ) : (
          <>
            {showIplWidget ? (
              <IPLWidget {...props} prefetchedData={iplData} />
            ) : (
              <TOIPlusWidget {...props} />
            )}
          </>
        )}
      </li>
    </ErrorBoundary>
  );
};

export default EpaperIplWidgetWrapper;
